import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getFileName, getFileType } from 'utils/helper';
import { useParams } from 'react-router-dom';
import { ShareResumeContainer } from './Profiles.style';
import { BrandIconSpinner, DocPreview } from 'components';
import { handleGetResume } from 'redux/features/UserResumeSlice';

import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';

export default function ShareResume() {
    const dispatch = useDispatch();
    const { resumeid } = useParams();

    const [resumePath, setResumePath] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isErr, setIsErr] = useState(false);

    useEffect(() => {
        dispatch(handleGetResume(resumeid)).then((data) => {
            if(data?.data) {
            setResumePath(data?.data);
            } else {
                setIsErr(true);
            }
            setIsLoading(false);
        }).catch((err) => {
            console.log(err);
            setIsErr(true);
            setIsLoading(false);
        })
    }, []);

    return (
        <ShareResumeContainer>
            {isLoading
                ? <BrandIconSpinner loading={isLoading} />
                : isErr
                    ? <div className="no-data-found">
                    <NoDataFound />
                    <div>Something went wrong! Please check if the URL is correct.</div>
                  </div>
                    : getFileType(resumePath?.resume) === 'pdf'
                    ? <DocPreview src={resumePath?.resume} readOnly isScroll />
                    : <iframe
                        title={getFileName(resumePath?.resume)}
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${resumePath?.resume}`}
                        height="750px"
                        width="100%"
                        style={{ border: "none" }}
                    />}
        </ShareResumeContainer>
    );
}